module.exports = __webpack_public_path__ + "img/icon_indi_zeroemission_on88888.90a48c9d.svg";